
// TODO: handle other type of pluralization i.e. person - people
const pluralizeString = (noun, count, suffix = 's') => {
    return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

export default pluralizeString;
